const img = (name) => `/assets/img/${name}.webp`;

export const SITE = {
  name: "Global Industry Group, Inc.",
  shortName: "Global Industry Group",
  url: "https://www.globalindg.com",
  phone: "(281) 607-1002",
  phoneHref: "tel:2816071002",
  email: "Sales@Globalindg.com",
  logo: "/assets/global-industry-group-logo-600.webp",
  logoWhite: "/assets/global-industry-group-logo-white-600.webp",
  defaultOgImage: "https://www.globalindg.com/assets/img/refinery-datacenter-hero.webp",
  heroImage: img("industrial-refinery-facility-hero"),
  dataCenterImage: img("data-center-server-racks"),
};

export const LOCATIONS = [
  {
    id: "houston",
    label: "Houston, Texas",
    lines: ["3129 Kingsley Drive, Suite 520", "Pearland, Texas 77584"],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=3129+Kingsley+Drive+Suite+520+Pearland+Texas+77584",
  },
  {
    id: "dallas",
    label: "Dallas, Texas",
    lines: ["1910 Pacific Avenue, Suite 2000", "Dallas, Texas 75201"],
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=1910+Pacific+Avenue+Suite+2000+Dallas+Texas+75201",
  },
];

export const SERVICES = [
  {
    slug: "mechanical-services",
    name: "Mechanical Services",
    h1: "Industrial Mechanical Services in Texas",
    description:
      "Complete mechanical construction and maintenance solutions designed to maximize plant reliability and operational efficiency.",
    capabilities: [
      "Process Piping",
      "Utility Piping",
      "Stainless Steel Piping",
      "Carbon Steel Piping",
      "Pipe Supports",
      "Equipment Installation",
      "Pump Installation",
      "Valve Installation",
      "Mechanical Repairs",
      "Facility Modifications",
      "Turnarounds & Shutdowns",
      "Maintenance Services",
      "Field Welding",
      "Equipment Setting & Alignment",
    ],
    image: img("industrial-process-piping-sunset"),
    imageAlt: "Industrial process piping and structural steel inside an operating facility at dusk",
    seo: {
      title: "Industrial Mechanical Services in Texas | Global Industry Group",
      description:
        "Process piping, equipment installation, turnarounds, and mechanical maintenance from a Texas industrial mechanical contractor. Self-performed by one team.",
    },
  },
  {
    slug: "structural-steel",
    name: "Structural Steel",
    h1: "Industrial Structural Steel Services",
    description:
      "Structural steel solutions for industrial facilities, manufacturing plants, commercial buildings, and mission-critical infrastructure.",
    capabilities: [
      "Structural Steel Fabrication and Erection",
      "Miscellaneous Steel",
      "Pipe Racks",
      "Equipment Support Structures",
      "Access Platforms",
      "Equipment Frames",
      "Structural Reinforcement",
      "Structural Repairs",
      "Base Plates",
      "Field Welding",
      "Steel Modifications",
    ],
    image: img("structural-steel-erection"),
    imageAlt: "Ironworkers erecting structural steel on an industrial project",
    seo: {
      title: "Industrial Structural Steel Contractor in Texas | Global Industry Group",
      description:
        "Structural steel fabrication and erection, pipe racks, platforms, and structural repairs for Texas industrial and mission-critical facilities.",
    },
  },
  {
    slug: "civil-construction",
    name: "Civil Construction",
    h1: "Industrial Civil Construction Services",
    description:
      "Civil construction services supporting industrial operations and infrastructure improvements.",
    capabilities: [
      "Concrete Foundations",
      "Tank Foundations",
      "Equipment Pads",
      "Structural Concrete Repairs",
      "Containment Systems",
      "Secondary Containment",
      "Grouting",
      "Anchor Bolt Installation",
      "Excavation Support",
      "Concrete Demolition",
      "Site Improvements",
    ],
    image: img("civil-construction-foundations"),
    imageAlt: "Excavator placing engineered fill for industrial concrete foundations",
    seo: {
      title: "Industrial Civil Contractor in Texas | Global Industry Group",
      description:
        "Concrete foundations, tank foundations, containment systems, and site improvements for industrial facilities across Texas.",
    },
  },
  {
    slug: "industrial-coatings",
    name: "Industrial Coatings",
    h1: "Industrial Coatings & Corrosion Protection",
    description:
      "Protective coating systems designed to extend asset life and minimize corrosion.",
    capabilities: [
      "Abrasive Blasting",
      "Industrial Painting",
      "Protective Coatings",
      "Tank Linings",
      "Pipe Coatings",
      "Structural Steel Coatings",
      "Concrete Coatings",
      "Secondary Containment Coatings",
      "Chemical Resistant Coatings",
      "Corrosion Control",
      "Surface Preparation",
      "Maintenance Painting",
    ],
    image: img("storage-tank-protective-coating"),
    imageAlt: "Freshly coated industrial storage tank with spiral stairway",
    seo: {
      title: "Industrial Coatings Contractor in Texas | Global Industry Group",
      description:
        "Abrasive blasting, protective coatings, tank linings, and corrosion control that extend asset life for Texas industrial facilities.",
    },
  },
  {
    slug: "fireproofing",
    name: "Fireproofing",
    h1: "Industrial & Commercial Fireproofing Services",
    description:
      "Passive fire protection systems for industrial and commercial facilities.",
    capabilities: [
      "Cementitious Fireproofing",
      "Intumescent Fireproofing",
      "Structural Steel Fireproofing",
      "Fireproofing Repairs",
      "Fireproofing Removal",
    ],
    image: img("fireproofing-steel-application"),
    imageAlt: "Crew applying cementitious fireproofing to structural steel",
    seo: {
      title: "Industrial Fireproofing Services in Texas | Global Industry Group",
      description:
        "Cementitious and intumescent fireproofing, repairs, and removal for industrial and commercial facilities across Texas.",
    },
  },
  {
    slug: "insulation-heat-tracing",
    name: "Insulation & Heat Tracing",
    h1: "Industrial Insulation & Heat Tracing",
    description:
      "Energy-efficient insulation systems designed to improve safety and process performance.",
    capabilities: [
      "Hot Insulation",
      "Cold Insulation",
      "Cryogenic Insulation",
      "Mechanical Insulation",
      "Removable Insulation Blankets",
      "Steam Tracing",
      "Metal Jacketing",
      "Equipment Insulation",
      "Pipe Insulation",
    ],
    image: img("pipe-insulation-jacketing-corridor"),
    imageAlt: "Metal-jacketed insulated piping running through an industrial corridor",
    seo: {
      title: "Industrial Insulation & Heat Tracing Contractor | Global Industry Group",
      description:
        "Hot, cold, and cryogenic insulation, steam tracing, and metal jacketing installed by a Texas industrial insulation contractor.",
    },
  },
  {
    slug: "scaffolding",
    name: "Scaffolding",
    h1: "Industrial Scaffolding Services",
    description:
      "Safe and dependable access systems for construction, maintenance, and turnarounds.",
    capabilities: [
      "Industrial Scaffolding",
      "Maintenance Scaffolds",
      "Confined Space Scaffolds",
      "Pipe Rack Access",
      "Tank Scaffolding",
      "Turnaround Support",
      "Emergency Access Solutions",
    ],
    image: img("industrial-scaffolding-services"),
    imageAlt: "Engineered industrial scaffolding providing access to plant piping and structure",
    seo: {
      title: "Industrial Scaffolding Services in Texas | Global Industry Group",
      description:
        "Safe, dependable industrial scaffolding and access systems for construction, maintenance, turnarounds, and confined spaces.",
    },
  },
  {
    slug: "environmental-services",
    name: "Environmental Services",
    h1: "Industrial Environmental Services",
    description:
      "Environmental solutions supporting industrial compliance, remediation, and facility maintenance.",
    capabilities: [
      "Asbestos Abatement",
      "Lead Abatement",
      "Mold Remediation",
      "Industrial Cleaning",
      "Water Mitigation",
      "Spill Response",
      "Industrial Wastewater Management Support",
      "Waste Management Coordination",
      "Decontamination Services",
      "Containment Systems",
    ],
    image: img("environmental-remediation-crew"),
    imageAlt: "Protected environmental professional performing industrial remediation work",
    seo: {
      title: "Industrial Environmental Services in Texas | Global Industry Group",
      description:
        "Asbestos and lead abatement, mold remediation, industrial cleaning, and spill response from a Texas industrial contractor.",
    },
  },
  {
    slug: "general-contracting",
    name: "General Contracting",
    h1: "Industrial General Contracting",
    description:
      "Single-source project management from planning through completion.",
    capabilities: [
      "Design-Build",
      "Construction Management",
      "Facility Expansions",
      "Interior Build-Outs",
      "Plant Maintenance",
      "Capital Projects",
      "Tenant Improvements",
      "Industrial Renovations",
      "Project Management",
      "Procurement Coordination",
    ],
    image: img("construction-project-team"),
    imageAlt: "Construction team coordinating work on a large industrial facility project",
    seo: {
      title: "Industrial General Contractor in Texas | Global Industry Group",
      description:
        "Design-build, construction management, facility expansions, and capital projects delivered by a Texas industrial general contractor.",
    },
  },
];

export const INDUSTRIES = [
  {
    slug: "chemical-petrochemical",
    name: "Chemical & Petrochemical",
    h1: "Chemical & Petrochemical Construction Services",
    blurb:
      "Maintenance, shutdowns, mechanical construction, coatings, fireproofing, and civil improvements for operating chemical and petrochemical facilities.",
    intro:
      "Global Industry Group supports operating chemical and petrochemical facilities with the construction and maintenance disciplines these complex environments demand. Our self-performed services help owners keep plants safe, compliant, and productive.",
    capabilities: [
      "Plant Maintenance",
      "Shutdowns & Turnarounds",
      "Mechanical Construction",
      "Protective Coatings",
      "Fireproofing",
      "Civil Improvements",
    ],
    image: img("petrochemical-refinery-stacks"),
    imageAlt: "Petrochemical refinery process towers and stacks",
    seo: {
      title: "Chemical & Petrochemical Construction Services | Global Industry Group",
      description:
        "Industrial contractor supporting Texas chemical and petrochemical facilities with maintenance, turnarounds, mechanical construction, and coatings.",
    },
  },
  {
    slug: "manufacturing",
    name: "Industrial Manufacturing",
    h1: "Industrial Manufacturing Construction & Maintenance",
    blurb:
      "Facility upgrades, maintenance, equipment installation, and production support for Texas manufacturing operations.",
    intro:
      "Manufacturing facilities depend on reliable infrastructure and minimal downtime. Global Industry Group delivers facility upgrades, equipment installation, and ongoing maintenance that keep production lines supported and operations moving.",
    capabilities: [
      "Facility Upgrades",
      "Equipment Installation",
      "Plant Maintenance",
      "Production Support",
      "Structural Modifications",
      "Protective Coatings",
    ],
    image: img("manufacturing-robotics"),
    imageAlt: "Automated manufacturing line inside a Texas industrial facility",
    seo: {
      title: "Industrial Manufacturing Construction & Maintenance | Global Industry Group",
      description:
        "Facility upgrades, equipment installation, and maintenance for Texas manufacturing plants — one contractor, multiple disciplines.",
    },
  },
  {
    slug: "oil-gas",
    name: "Oil & Gas",
    h1: "Oil & Gas Construction & Maintenance Services",
    blurb:
      "Construction, maintenance, and specialty services supporting upstream, midstream, and downstream operations.",
    intro:
      "Global Industry Group provides multi-discipline construction and maintenance support for oil and gas operations, delivering mechanical, structural, civil, and specialty services through one coordinated team.",
    capabilities: [
      "Mechanical & Piping",
      "Structural Steel",
      "Civil & Foundations",
      "Protective Coatings",
      "Insulation",
      "Maintenance Support",
    ],
    image: img("refinery-monochrome"),
    imageAlt: "Oil and gas processing facility with towers and piping",
    seo: {
      title: "Oil & Gas Construction & Maintenance Contractor | Global Industry Group",
      description:
        "Multi-discipline construction and maintenance services for Texas oil and gas facilities, delivered by one self-performing contractor.",
    },
  },
  {
    slug: "lng-facilities",
    name: "LNG Facilities",
    h1: "LNG Facility Construction & Maintenance Services",
    blurb:
      "Mechanical, cryogenic insulation, structural, and civil services for LNG and industrial gas facilities.",
    intro:
      "LNG and industrial gas facilities require contractors who understand cryogenic systems, heavy mechanical work, and disciplined execution. Global Industry Group supports these facilities with construction, maintenance, and specialty services.",
    capabilities: [
      "Cryogenic Insulation",
      "Process Piping",
      "Structural Steel",
      "Tank Foundations",
      "Protective Coatings",
      "Maintenance Services",
    ],
    image: img("cryogenic-insulated-pipe-supports"),
    imageAlt: "Large-diameter cryogenic insulated piping and pipe supports",
    seo: {
      title: "LNG Facility Construction Services in Texas | Global Industry Group",
      description:
        "Cryogenic insulation, process piping, structural steel, and foundations for LNG and industrial gas facilities in Texas.",
    },
  },
  {
    slug: "energy-power",
    name: "Energy & Power Generation",
    h1: "Energy & Power Construction Services",
    blurb:
      "Infrastructure improvements, mechanical systems, structural steel, coatings, and maintenance for power generation facilities.",
    intro:
      "Power generation facilities operate under demanding reliability expectations. Global Industry Group supports energy and power clients with infrastructure improvements, mechanical systems, structural steel, coatings, and ongoing maintenance.",
    capabilities: [
      "Infrastructure Improvements",
      "Mechanical Systems",
      "Structural Steel",
      "Protective Coatings",
      "Insulation & Heat Tracing",
      "Facility Maintenance",
    ],
    image: img("power-plant-cooling-towers"),
    imageAlt: "Power generation station with cooling towers",
    seo: {
      title: "Energy & Power Construction Services in Texas | Global Industry Group",
      description:
        "Mechanical systems, structural steel, coatings, and maintenance for Texas energy and power generation facilities.",
    },
  },
  {
    slug: "data-centers",
    name: "Data Centers & Mission-Critical Facilities",
    h1: "Data Center & Mission-Critical Construction Services",
    blurb:
      "Specialized construction and maintenance for facilities where uptime is essential — mechanical infrastructure, chilled water piping, structural steel, and more.",
    intro:
      "Global Industry Group provides specialized construction and maintenance services supporting reliable operations for facilities where uptime is essential. From cooling water systems to structural steel, our self-performed disciplines keep mission-critical infrastructure built right and built safe.",
    capabilities: [
      "Mechanical Infrastructure",
      "Cooling Water Systems",
      "Chilled Water Piping",
      "Structural Steel",
      "Equipment Foundations",
      "Protective Coatings",
      "Fireproofing",
      "Insulation",
      "Scaffolding",
      "Facility Maintenance",
      "Environmental Services",
    ],
    image: img("data-center-server-racks"),
    imageAlt: "Server racks inside a modern mission-critical data center",
    secondaryImage: img("chiller-plant-mechanical-room"),
    secondaryImageAlt: "Chilled water piping and mechanical equipment inside a data center chiller plant",
    featured: true,
    seo: {
      title: "Data Center & Mission-Critical Construction Texas | Global Industry Group",
      description:
        "Texas data center construction and mission-critical mechanical contractor: chilled water piping, cooling systems, structural steel, and facility maintenance.",
    },
  },
  {
    slug: "water-wastewater",
    name: "Water & Wastewater",
    h1: "Water & Wastewater Construction Services",
    blurb:
      "Construction and maintenance for treatment plants, pumping stations, industrial water facilities, and utility infrastructure.",
    intro:
      "Water and wastewater infrastructure demands durable construction and disciplined execution. Global Industry Group supports treatment plants, pumping stations, industrial water facilities, and utility infrastructure with civil, mechanical, structural, and coatings services.",
    capabilities: [
      "Treatment Plant Construction",
      "Pumping Stations",
      "Industrial Water Facilities",
      "Utility Infrastructure",
      "Concrete & Containment",
      "Protective Coatings",
    ],
    image: img("wastewater-treatment-aerial"),
    imageAlt: "Aerial view of a water and wastewater treatment facility",
    seo: {
      title: "Water & Wastewater Construction Services Texas | Global Industry Group",
      description:
        "Construction and maintenance for Texas water and wastewater treatment plants, pumping stations, and utility infrastructure.",
    },
  },
  {
    slug: "food-beverage",
    name: "Food & Beverage Processing",
    h1: "Food & Beverage Facility Construction Services",
    blurb:
      "Construction and maintenance support for hygienic processing environments and production facilities.",
    intro:
      "Food and beverage processors need contractors who respect production schedules and hygienic environments. Global Industry Group supports processing facilities with mechanical, structural, civil, and specialty services planned around operations.",
    capabilities: [
      "Stainless Steel Piping",
      "Equipment Installation",
      "Facility Upgrades",
      "Insulation Systems",
      "Protective Coatings",
      "Maintenance Support",
    ],
    image: img("food-beverage-brewery-tanks"),
    imageAlt: "Stainless steel processing vessels inside a food and beverage facility",
    seo: {
      title: "Food & Beverage Facility Construction | Global Industry Group",
      description:
        "Mechanical, structural, and specialty construction services for Texas food and beverage processing facilities.",
    },
  },
  {
    slug: "renewable-energy",
    name: "Renewable Energy",
    h1: "Renewable Energy Construction Services",
    blurb:
      "Civil, structural, and mechanical services supporting renewable energy infrastructure.",
    intro:
      "Renewable energy projects require dependable civil, structural, and mechanical execution. Global Industry Group supports renewable infrastructure with foundations, structural steel, and facility services.",
    capabilities: [
      "Concrete Foundations",
      "Structural Steel",
      "Mechanical Systems",
      "Site Improvements",
      "Protective Coatings",
      "Facility Maintenance",
    ],
    image: img("wind-turbines-dusk"),
    imageAlt: "Wind turbines at dusk supporting renewable energy generation",
    secondaryImage: img("solar-farm-aerial"),
    secondaryImageAlt: "Aerial view of a utility-scale solar energy facility",
    seo: {
      title: "Renewable Energy Construction Services | Global Industry Group",
      description:
        "Foundations, structural steel, and mechanical services supporting Texas renewable energy infrastructure.",
    },
  },
  {
    slug: "commercial-industrial",
    name: "Commercial & Industrial Facilities",
    h1: "Commercial & Industrial Facility Construction",
    blurb:
      "Construction, renovation, and maintenance services for commercial and industrial facilities.",
    intro:
      "Global Industry Group delivers construction, renovation, and maintenance services for commercial and industrial facilities — from interior build-outs and tenant improvements to structural upgrades and capital projects.",
    capabilities: [
      "Facility Expansions",
      "Interior Build-Outs",
      "Tenant Improvements",
      "Structural Upgrades",
      "Fireproofing",
      "Building Maintenance",
    ],
    image: img("commercial-towers"),
    imageAlt: "Modern commercial facilities and building exteriors",
    seo: {
      title: "Commercial & Industrial Facility Construction | Global Industry Group",
      description:
        "Facility expansions, build-outs, and structural upgrades for Texas commercial and industrial properties.",
    },
  },
  {
    slug: "epc",
    name: "Engineering, Procurement & Construction (EPC)",
    h1: "Construction Support for EPC Projects",
    blurb:
      "Self-performed construction services that integrate with EPC project delivery teams.",
    intro:
      "Global Industry Group integrates with engineering, procurement, and construction teams as a reliable self-performing contractor, delivering mechanical, structural, civil, and specialty scopes with one point of contact.",
    capabilities: [
      "Self-Performed Construction",
      "Mechanical & Piping Scopes",
      "Structural & Civil Scopes",
      "Specialty Services",
      "Schedule-Driven Execution",
      "Procurement Coordination",
    ],
    image: img("engineering-blueprints"),
    imageAlt: "Engineering drawings and project planning for an industrial facility",
    seo: {
      title: "Construction Support for EPC Projects | Global Industry Group",
      description:
        "Self-performed mechanical, structural, and civil construction scopes that integrate with EPC project delivery teams in Texas.",
    },
  },
  {
    slug: "government",
    name: "Government Facilities",
    h1: "Government Facility Construction & Maintenance",
    blurb:
      "Disciplined construction and maintenance services for government and public-sector facilities.",
    intro:
      "Government and public-sector facilities require accountable, safety-focused contractors. Global Industry Group delivers construction, maintenance, and specialty services for government facilities with detailed planning and reliable execution.",
    capabilities: [
      "Facility Construction",
      "Building Maintenance",
      "Structural Repairs",
      "Protective Coatings",
      "Environmental Services",
      "Civil Improvements",
    ],
    image: img("government-building"),
    imageAlt: "Government facility building with architectural columns",
    seo: {
      title: "Government Facility Construction Services | Global Industry Group",
      description:
        "Construction, maintenance, and specialty services for Texas government and public-sector facilities.",
    },
  },
];

export const WHY_POINTS = [
  {
    title: "Safety First",
    text: "Safety is our top priority. We are committed to protecting our people, clients, facilities, and communities.",
    icon: "ShieldCheck",
  },
  {
    title: "Skilled Team",
    text: "Experienced professionals and skilled craftsmen delivering quality work every time.",
    icon: "Users",
  },
  {
    title: "Proven Performance",
    text: "Focused on quality, schedule, efficiency, and dependable project execution.",
    icon: "Cog",
  },
  {
    title: "One Point of Contact",
    text: "Streamlined communication and accountability from planning through completion.",
    icon: "Handshake",
  },
];

export const BENEFITS = [
  "Single Point of Contact",
  "Self-Performed Construction Services",
  "Improved Project Coordination",
  "Faster Mobilization",
  "Reduced Project Risk",
  "Enhanced Quality Control",
  "Strong Safety Culture",
  "Flexible Workforce",
  "Reliable Schedule Performance",
  "Cost-Effective Project Delivery",
];

export const CLIENTS = [
  { name: "Energy Transfer", logo: "/assets/clients/energy-transfer.png" },
  { name: "Arkema", logo: "/assets/clients/arkema.png" },
  { name: "Nalco Water / Ecolab", logo: "/assets/clients/nalco-water.png" },
  { name: "SLB", logo: "/assets/clients/slb.png" },
  { name: "Chemours", logo: "/assets/clients/chemours.png" },
  { name: "Kuraray", logo: "/assets/clients/kuraray.png" },
  { name: "Nouryon", logo: "/assets/clients/nouryon.png" },
  { name: "OxyChem / Oxy Chemical", logo: "/assets/clients/oxychem.png" },
  { name: "Topsoe", logo: "/assets/clients/topsoe.png" },
  { name: "Valvoline", logo: "/assets/clients/valvoline.png" },
  { name: "Lummus Technology", logo: "/assets/clients/lummus-technology.png" },
  { name: "Raven Butene", logo: "/assets/clients/raven-butene.png" },
  { name: "Texas Department of Transportation (TxDOT)", logo: "/assets/clients/txdot.png" },
  { name: "Sheppard Air Force Base", logo: "/assets/clients/sheppard-afb.png" },
  { name: "Dallas Fort Worth International Airport", logo: "/assets/clients/dfw-airport.png" },
  { name: "Dr Pepper", logo: "/assets/clients/dr-pepper.png" },
  { name: "Dallas Independent School District", logo: "/assets/clients/dallas-isd.png" },
  { name: "ChampionX", logo: "/assets/clients/championx.png" },
  { name: "Petromax", logo: "/assets/clients/petromax.png" },
];

export const CLIENTS_STATEMENT =
  "Experience includes work performed across industrial, infrastructure, and government facilities.";

export const PROJECT_TYPES = [
  { name: "Piping Systems", image: img("refinery-night-blue"), imageAlt: "Industrial piping systems within an operating facility at night" },
  { name: "Tank Construction", image: img("industrial-tank-farm-night"), imageAlt: "Industrial storage tank farm at night" },
  { name: "Structural Steel", image: img("steel-worker-beams"), imageAlt: "Ironworker connecting structural steel members" },
  { name: "Plant Maintenance", image: img("chiller-plant-mechanical-room"), imageAlt: "Craftsman maintaining mechanical equipment inside a plant" },
  { name: "Building Construction", image: img("highrise-cranes"), imageAlt: "Large building construction with tower cranes" },
];

export const PROJECT_CATEGORIES = [
  { name: "Mechanical & Piping", text: "Process and utility piping systems, equipment setting, and mechanical construction executed by self-performing crews." },
  { name: "Tanks & Foundations", text: "Tank foundations, containment systems, and heavy civil work supporting storage and process infrastructure." },
  { name: "Structural Steel", text: "Fabrication and erection of structural steel, pipe racks, platforms, and equipment support structures." },
  { name: "Industrial Coatings", text: "Surface preparation, protective coatings, and tank linings that extend asset life and control corrosion." },
  { name: "Maintenance & Turnarounds", text: "Planned maintenance, shutdowns, and turnaround support executed with detailed planning and skilled supervision." },
  { name: "Civil Construction", text: "Concrete foundations, equipment pads, and site improvements for industrial operations." },
  { name: "Mission-Critical Infrastructure", text: "Mechanical infrastructure, chilled water piping, and structural work for data centers and mission-critical facilities." },
  { name: "Environmental Services", text: "Abatement, remediation, and industrial cleaning performed by properly protected professionals." },
];

export const SAFETY_COMPLIANCE = [
  "ISNetworld®",
  "Avetta®",
  "Veriforce®",
  "DISA®",
  "AMPP",
];

export const SAFETY_QUALIFICATIONS = [
  "TDLR Licensed Contractor",
  "Texas Department of State Health Services (DSHS), where applicable",
  "OSHA-Compliant Safety Programs",
  "Client-Specific Safety Orientation & Qualification Programs",
];

export const APPROACH_POINTS = [
  { title: "Planning", text: "Every scope begins with detailed planning, clear sequencing, and defined expectations." },
  { title: "Communication", text: "One point of contact keeps clients informed from kickoff through completion." },
  { title: "Safety", text: "Work is planned and executed to protect people, facilities, and operations." },
  { title: "Coordination", text: "Multiple disciplines under one team means fewer handoffs and tighter schedules." },
  { title: "Quality", text: "Experienced supervision and skilled craftsmen deliver work built to last." },
  { title: "Reliable Execution", text: "Dependable performance on schedule, on budget, and to specification." },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services", dropdown: true },
  { label: "Industries", path: "/industries" },
  { label: "Projects", path: "/projects" },
  { label: "Safety & Quality", path: "/safety-quality" },
  { label: "Careers", path: "/careers" },
  { label: "Contact Us", path: "/contact" },
];

export const SEARCH_PAGES = [
  { name: "About Global Industry Group", path: "/about", group: "Pages", keywords: "company about who we are approach" },
  { name: "Projects & Experience", path: "/projects", group: "Pages", keywords: "projects experience case studies clients" },
  { name: "Safety & Quality", path: "/safety-quality", group: "Pages", keywords: "safety quality osha isnetworld avetta veriforce disa" },
  { name: "Careers", path: "/careers", group: "Pages", keywords: "careers jobs welder pipefitter talent network hiring" },
  { name: "Contact Us", path: "/contact", group: "Pages", keywords: "contact quote phone email houston dallas pearland" },
  { name: "Services Overview", path: "/services", group: "Pages", keywords: "services construction maintenance industrial" },
  { name: "Industries We Serve", path: "/industries", group: "Pages", keywords: "industries sectors markets" },
];

export const FAQS = {
  "data-centers": [
    {
      q: "Can Global Industry Group work inside an operating data center?",
      a: "Yes. Work is planned around live operations with detailed sequencing, clear communication, and strict safety controls so uptime is never compromised.",
    },
    {
      q: "What mechanical scopes do you self-perform for data centers?",
      a: "Chilled water piping, cooling water systems, mechanical infrastructure, equipment setting and alignment, and ongoing facility maintenance — all self-performed by our own crews.",
    },
    {
      q: "Do you support both data center construction and maintenance?",
      a: "Both. Construction scopes include structural steel, equipment foundations, fireproofing, insulation, and protective coatings; after turnover we support the facility with maintenance and environmental services.",
    },
    {
      q: "Where do you provide mission-critical construction services?",
      a: "Throughout Texas, coordinated from our Houston (Pearland) and Dallas offices.",
    },
  ],
};
